import { CopilotPanelContentBase, CopilotPanelContext } from 'models/copilot/copilotBridge';
import { CopilotConversation } from 'models/copilot/copilotConversation';
import { CopilotConversationDTO } from 'models/dto/copilot/copilotConversationDTO';

export class TenantProcessStateControlEvidenceAudit {
  controlId: number;

  selectedRecommendationIds: number[];

  createdTaskIds: number[];

  conversation: CopilotConversation;

  // the standards the audit runs under (tenant norm ids); empty on a state written before standards
  normIds: number[];

  constructor() {
    this.controlId = 0;
    this.selectedRecommendationIds = [];
    this.createdTaskIds = [];
    this.conversation = new CopilotConversation();
    this.normIds = [];
  }
}

export class TenantProcessStateControlEvidenceAuditDTO {
  controlId: number;

  selectedRecommendationIds: number[];

  createdTaskIds: number[];

  conversation: CopilotConversationDTO;

  // Audit period (ISO datetime). Undefined lets the backend default to the current audit year.
  periodStart?: string;

  periodEnd?: string;

  // The standards the audit runs under (tenant norm ids): the panel's choice among the control's
  // linked standards. Empty lets the backend default to every linked standard (and refuse a control
  // linked to none).
  normIds?: number[];

  constructor() {
    this.controlId = 0;
    this.selectedRecommendationIds = [];
    this.createdTaskIds = [];
    this.conversation = new CopilotConversationDTO();
  }
}

export class CopilotControlAuditContent extends CopilotPanelContentBase {
  public readonly context: CopilotPanelContext;

  controlId: number;

  // The standards the control is linked to and that are active: the candidates a control audit can
  // run under. None refuses the audit, one is taken silently, several are asked in the panel.
  candidateNormIds: number[];

  // The standards the current run was started under; stamped by the panel definition.
  normIds: number[];

  // Whether the scene offers Draft automation for the control (isAutomationDraftingAvailable); stamped by the scene.
  canDraftAutomation = false;

  constructor(controlId: number, candidateNormIds: number[] = [], context = CopilotPanelContext.ControlEvidenceAudit) {
    super();
    this.context = context;
    this.controlId = controlId;
    this.candidateNormIds = candidateNormIds;
    this.normIds = [];
  }
}

export class CopilotControlEvidenceAuditContent extends CopilotControlAuditContent {
  constructor(controlId: number, candidateNormIds: number[] = []) {
    super(controlId, candidateNormIds, CopilotPanelContext.ControlEvidenceAudit);
  }
}
